document.addEventListener("turbolinks:load", function () {
  $('.js-modal-open').on('click', function () {
    $('.js-modal-overlay').show();
    $('.js-modal-dialog').fadeIn(250);
  });
  $('.js-modal-close,.js-modal-overlay').on('click', function () {
    $('.js-modal-overlay').hide();
    $('.js-modal-dialog').hide();
  });
  $('.js-modal-overlay.js-notice-modal').each(function () {
    const time = $(this).data('time');
    if (time && ((new Date()).getTime() / 1000 - time > 3)) {
      return;
    }
    $('.js-notice-modal.js-modal-overlay').show();
    $('.js-notice-modal.js-modal-dialog').fadeIn(250);
    $('.js-notice-modal .js-modal-close,.js-notice-modal.js-modal-overlay').on('click', function () {
      $('.js-notice-modal.js-modal-overlay').remove();
      $('.js-notice-modal.js-modal-dialog').remove();
    });
  });
});
